<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      
      <v-flex md12>
        <core-table
          ref="accountTable"
          title="Accounts"
          :config="config"
          @confirm="confirmUser"
          @emulateUser="emulateUser"
          :hideUpsert="$store.getters.user.role!=='Administrator' && $store.getters.user.role!=='EMN Logistic'"
          :hideCreate="$store.getters.user.role==='EMN Logistic'"
          @disableUser="disableUser"
        >

          <template slot='headerActions'>
            <v-tooltip
              top>
              <template
                slot="activator"
                slot-scope="{ on }">

                 <v-btn
                  v-on="on"
                  color="secondary"
                  @click="open_in_new()">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>

              </template>
              <span>Request New Account</span>
            </v-tooltip>        
          </template>
        </core-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { put } from '@/api/base_entity.js'
import config from './config_index.js'
import { startEmulation } from '@/utils/auth'


export default {
  data () {
    return { config }
  },
  methods: {
    mounted() {
      // if(this.$route.params.id) {

      // }
    },
    async confirmUser(item) {

      const ret = await this.$root.$confirm.open('Confirm Account', 'Are you sure you want to confirm this account?', { color: 'red' })
      if (!ret) {
        return
      }

      put("confirm_account", item.id, {}).then( () => {
        this.$refs.accountTable.getData()
        this.$root.$emit('openSnackbar', {
          message: 'Account confirmed successfully',
          color: 'success'
        })
      }).catch( () => {
        this.$root.$emit('openSnackbar', {
          message: 'An error occurred during account confirmation.',
          color: 'error'
        })
      })
    },
    async disableUser(item) {

      const ret = await this.$root.$confirm.open('Disable Account', 'Are you sure you want to disable this account ?', { color: 'red' })
      if (!ret) {
        return
      }

      put("disable_account", item.id, {}).then( () => {
        this.$refs.accountTable.getData()
        this.$root.$emit('openSnackbar', {
          message: 'Account disabled successfully',
          color: 'success'
        })
      }).catch( () => {
        this.$root.$emit('openSnackbar', {
          message: 'An error occurred during account disabling.',
          color: 'error'
        })
      })
    },
    emulateUser(user) {
      this.$store.dispatch("app/startLoading")
      startEmulation(user.id)
      location.assign('/#/dashboard')
      location.reload()
    },
    open_in_new() {
      window.open(window.location.origin + '/#/request_account', '_blank')
    }
  }
}
</script>
